<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案222信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="width: 600px;">
        <el-form-item label="方案名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入方案名称" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="流量方" prop="trafficOrgId">
          <el-select
            v-model="form.trafficOrgId"
            style="width: 100%;"
            filterable
            remote
            reserve-keyword
            placeholder="请输入搜索关键词"
            :remote-method="selectTrafficOrgId"
          >
            <el-option v-for="item in OrgList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="生效时间" prop="startTime">
          <el-row>
            <el-col :span="10">
              <el-date-picker v-model="form.startTime" type="date" style="width: 100%;" placeholder="请选择日期" value-format="yyyy-MM-dd" />
            </el-col>
            <el-col :span="4" style="text-align: center;">至</el-col>
            <el-col :span="10">
              <el-date-picker v-model="form.endTime" type="date" style="width: 100%;" placeholder="请选择日期" value-format="yyyy-MM-dd" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="font-size:12px;color: #00a6ff;">温馨提示：开始时间必填，结束时间非必填，如无结束时间则代表方案永久生效</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="结算周期" prop="trafficDay">
          <el-row>
            <el-col :span="20">
              <el-input v-model="form.trafficDay" placeholder="请输入结算周期" @input="checkCap" />
            </el-col>
            <el-col :span="4">
              <div style="text-align: center;">天</div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站价格信息</span>
      </div>
      <el-form ref="form2" :model="form2" label-width="100px">
        <el-form-item label="价格设置" prop="">
          <el-row :gutter="20">
            <el-col :span="3">
              <el-select v-model="form2.electricityType" placeholder="请选择" @change="changeType">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-input
                v-model="form2.electricity"
                placeholder="请输入"
                type="number" @blur="changeElecMoney(form2.electricity)"
              />
            </el-col>
            <el-col :span="1">
              <div v-show="form2.electricityType == 'fixed'">元</div>
              <div v-show="form2.electricityType == 'discount'">%</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="" prop="" style="margin-left:10px">
          <el-row :gutter="20">
            <el-col :span="3">
              <el-select v-model="form2.serviceFeeType" placeholder="请选择" @change="changeType2">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-input
                v-model="form2.serviceFee"
                placeholder="请输入"
                type="number" @blur="changeSerMoney(form2.electricity)"
              />
            </el-col>
            <el-col :span="1">
              <div v-show="form2.serviceFeeType == 'fixed'">元</div>
              <div v-show="form2.serviceFeeType == 'discount'">%</div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">开放电站</span>
      </div>
      <el-form ref="form3" :model="form3" :rules="rules3" label-width="100px" style="width: 600px;">
        <el-form-item label="提供方" prop="provider">
          <el-radio-group v-model="form3.provider" @change="changeClick">
            <el-radio :label="0">全平台直联</el-radio>
            <el-radio :label="1">加盟直联</el-radio>
            <el-radio :label="2">互联互通</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择运营商" prop="operatorOrgId">
          <STree v-model="form3.operatorOrgId" :data="operatorTree" style="width:400px;" />
          <el-button type="primary" plain size="small" @click="getDetail">确认</el-button>
        </el-form-item>
        <el-form-item label="选择电站" prop="target">
          <!-- <STree v-model="form3.target" :data="datatree" style="width:400px;"></STree> -->
          <StreeNew v-model="form3.target" checked-type="station" :data="datatree" style="width:400px;" />
        </el-form-item>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Xinzengliuliangfangan',
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      defaultTime: [],
      form: {
        name: '',
        trafficOrgId: '',
        startTime: '',
        endTime: '',
        trafficDay: ''
      },
      form2: {
        electricityType: 'discount',
        electricity: 100,
        serviceFeeType: 'discount',
        serviceFee: 100
      },
      form3: {
        operatorOrgId: '',
        provider: 0,
        target: ''
      },
      options: [{
        value: 'discount',
        label: '电费折扣'
      }
        // {
        //     value:'fixed',
        //     label:"电费一口价"
        // }
      ],
      options2: [{
        value: 'discount',
        label: '服务费折扣'
      }
        // {
        //     value:'fixed',
        //     label:"服务费一口价"
        // }
      ],
      rules: {
        name: [{
          required: true,
          message: '请输入方案名称',
          trigger: 'blur'
        }],
        trafficOrgId: [{
          required: true,
          message: '请选择流量方',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'blur'
        }],
        trafficDay: [{
          required: true,
          message: '请输入结算时间',
          trigger: 'blur'
        }]
      },
      rules3: {
        provider: [{
          required: true,
          message: '请选择提供方',
          trigger: 'blur'
        }],
        operatorOrgId: [{
          required: true,
          message: '请选择运营商',
          trigger: 'blur'
        }],
        target: [{
          required: true,
          message: '请选择开放电桩',
          trigger: 'blur'
        }]
      },
      datatree: [],
      OrgList: [],
      OrgList2: [],
      isShow: false,
      operatorTree: []
    }
  },
  computed: {},
  mounted() {
    this.selectTrafficOrgId()
    this.getOperator()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    changeType(val) {
      if (val == 'fixed') {
        this.form2.electricity = ''
      } else {
        this.form2.electricity = 100
      }
    },
    changeType2(val) {
      if (val == 'fixed') {
        this.form2.serviceFee = ''
      } else {
        this.form2.serviceFee = 100
      }
    },
    changeElecMoney(val) {
      if (this.form2.electricityType == 'fixed') {
        if (val) {
          this.form2.electricity = this.getFloat(val)
        }
      }
    },
    changeSerMoney(val) {
      if (this.form2.serviceFeeType == 'fixed') {
        if (val) {
          this.form2.serviceFee = this.getFloat(val)
        }
      }
    },
    checkCap(value) {
      value = value.replace(/^(0+)|[^\d]+/g, '')
      this.form.trafficDay = value
    },
    changeClick(val) {
      // if (val === 0) {
      //     this.isShow = false
      // } else if (val === 1) {
      //     this.isShow = true
      // }
      this.form3.provider = val
      this.form3.operatorOrgId = ''
      this.getOperator()
    },
    // 获取选择运营商树数据
    getOperator() {
      const data = {
        attr: this.form3.provider,
        orgTypes: '0,3',
        showOperatorName: true
      }
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getResponsibleOrgTree',
        data: data,
        method: 'get',
        callback: resp => {
          this.operatorTree = resp
        }
      })
    },
    getDetail() {
      if (this.form3.operatorOrgId) {
        this.orgId = this.form3.operatorOrgId.join(',')
        this.getStation(this.orgId)
      } else {
        this.$message('请选择运营商')
      }
    },
    getStation(val) {
      const data = {
        operatorId: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getTargetTree',
        data: data,
        method: 'get',
        callback: resp => {
          this.datatree = resp
        }
      })
    },

    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate(),
          this.$refs.form3.validate()
        ])
      } catch (error) {
        return
      }
      const target = this.form3.target.join(',')
      const data = {
        name: this.form.name,
        trafficOrgId: this.form.trafficOrgId,
        provider: this.form3.provider,
        operatorOrgId: this.form3.operatorOrgId.join(','),
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        trafficDay: this.form.trafficDay,

        electricityType: this.form2.electricityType,
        electricity: this.form2.electricity,
        serviceFeeType: this.form2.serviceFeeType,
        serviceFee: this.form2.serviceFee,

        target: target
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic',
        data: data,
        method: 'put',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success'
          })
          this.$router.go(-1)
        }
      })
    },

    cancel() {
      this.$router.go(-1)
    },
    selectTrafficOrgId(val) { // 流量方自动联想
      const data = {
        operatorName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getTrafficOrg',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.OrgList = resp
        }
      })
    },
    selectOperatorOrgId(val) { // 提供运营商自动联想
      const data = {
        orgName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getOperatorOrg',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.OrgList2 = resp
        }
      })
    }
    // getOrg(val) {
    //     let data = {}
    //     if(!val){
    //         data = {
    //             operatorId:''
    //         }
    //     }else{
    //         data = {
    //             operatorId:val
    //         }
    //     }
    //     this.$store.dispatch("form/handle", {
    //         url: "/business/traffic/getTargetTree",
    //         data:data,
    //         method: "get",
    //         callback: resp => {
    //             this.datatree = resp;
    //         }
    //     });
    // },
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/flowScheme/addFlowScheme.vue